/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ach-profile',
  template: require('./ach-profile.component.html')
})

export class AchProfileComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.fundInfo = this.appActions.getData('FundAccount');

    let allyAcc = this.form.inputs.allyBankAccount;
    let accountNumber= this.form.inputs.accountNumber;
    let bankName = this.form.inputs.bankName;

    const shortAccNum = this.fundInfo.accountNumber;
    let hiddenAccountNumber = shortAccNum.substr(shortAccNum.length - 4);
    hiddenAccountNumber = `******${hiddenAccountNumber}`;

    if (this.fundInfo && allyAcc) {
      allyAcc.noneditable = this.fundInfo.encryptedAccount;
      accountNumber.noneditable = hiddenAccountNumber;
      bankName.noneditable = this.fundInfo.bankName;
      if (this.fundInfo.allyBankAccount === true) {
        accountNumber.showUp = false;
        bankName.showUp = false; 
      } else {
        allyAcc.showUp = false;
      }
    }
  }

  updateOptionValue(event) {
    let iPath = null;
    let value = event.value;

    // Data for agreemenets needs to be replaced with the date
    if (event.id && event.id.indexOf('Agreement') >= 0 && value === true) {
      const date = new Date();
      const dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
      const mm = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
      const yyyy = date.getFullYear();

      value = `${mm}/${dd}/${yyyy}`;
      iPath = `ApplicationInformation.${event.id}`
    }

    if (iPath !== undefined) {
      this.appActions.setData(iPath, value)
    }
  }

  btnClick(e) {
    if (e.action === 'next') {
      this._achProfileCreate();
    } else if (e.action === 'cancel-app') {
      if (this.flowManager.isAuthed) {
        this.flowManager.ssoToAlly();
      } else {
        this.router.navigate(['/credentials']);
      }
    }
  }

  _achProfileCreate() {
    this.modal.loadingModel();

    let state = 2;
    if (this.fundInfo.allyBankAccount === true) {
      state = 3;
    }

    const fundAccountInfo = {
      routingNumber: this.fundInfo.routingNumber,
      bankAccountNumber: this.fundInfo.accountNumber,
      bankAccountType: this.fundInfo.bankAccountType,
      bankAccountOwnershipType: this.fundInfo.bankAccountOwnershipType,
      bankName: this.fundInfo.bankName,
      state: state
    }

    this.appProxy.createACHProfile(fundAccountInfo, resp => {
      this.appActions.setData('StepCompleted.achProfile', true);
      if (resp.statusCode === 'SUCCESS') {
        let depositRoute = this.flowManager.isIra ? 'deposit-funds-ira' :'deposit-funds';
        this.modal.closeModal(depositRoute);
        this.flowManager.hasACHProfile = true;
      } else if (!resp || resp.statusCode !== 'SUCCESS') {
        this.modal.closeModal('manual');
      }
    });
  }

}
